export default {
  validate: value => !!value,
  message: 'Vous devez accepter les conditions'
}
